import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Component, ViewChild } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';
import { VisibaSaveButtonComponent } from 'Public_old/src/app/Common/Directives/visibaSaveButton';
import { VisibaSvgIconRepository } from 'Public_old/src/app/Common/Directives/visibaSvgIconRepository';
import { GlobalValidator } from 'Public_old/src/app/Common/Classes/globalValidator';

@Component({ standalone: false, templateUrl: '../../ViewHtml/Develop/Components.html' })
export class ComponentsComponent {
	@ViewChild('saveBtnDynamicErrorText', { static: false }) saveBtnDynamicErrorText: VisibaSaveButtonComponent;

	formCG: UntypedFormGroup;
	form: any = {
		noValue: null,
		noValueNin: { nin: null, countryCode: 'SE' },
		value: 'Value',
		valueLongText: 'Det var en gång.. och den var saltad.',
		valuePhone: '+46701234567',
		valueNin: { nin: '8908121638', countryCode: 'SE' },
		time: new Date(new Date().setHours(10, 10, 0, 0)),
		noValueTime: null,
		valueDate: new Date(),
		valueDateSpan: [
			{
				from: new Date(new Date().setHours(0, 0, 0, 0)),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 2 * 24 * 60 * 60 * 1000),
				editable: true,
			},
		],
		valueDateSpanX2: [
			{
				from: new Date(new Date().setHours(0, 0, 0, 0)),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 2 * 24 * 60 * 60 * 1000),
				editable: true,
			},
			{
				from: new Date(new Date().setHours(0, 0, 0, 0) + 5 * 24 * 60 * 60 * 1000),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 8 * 24 * 60 * 60 * 1000),
				editable: true,
			},
		],
		valueDateSpanX2NotFirst: [
			{
				from: new Date(new Date().setHours(0, 0, 0, 0)),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 2 * 24 * 60 * 60 * 1000),
				editable: false,
			},
			{
				from: new Date(new Date().setHours(0, 0, 0, 0) + 5 * 24 * 60 * 60 * 1000),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 8 * 24 * 60 * 60 * 1000),
				editable: true,
			},
		],
		valueDateSpanXYNotFirst: [
			{
				from: new Date(new Date().setHours(0, 0, 0, 0)),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 2 * 24 * 60 * 60 * 1000),
				editable: false,
			},
			{
				from: new Date(new Date().setHours(0, 0, 0, 0) + 5 * 24 * 60 * 60 * 1000),
				to: new Date(new Date().setHours(0, 0, 0, 0) + 8 * 24 * 60 * 60 * 1000),
				editable: true,
			},
		],
	};
	listOptions = [
		{ value: 'Fredrik', icon: 'http://media-cdn.visibacare.com/service/public/logo/google-play-badge.png' },
		{ value: 'Görgen', icon: 'http://media-cdn.visibacare.com/service/public/logo/google-play-badge.png' },
		{ value: 'Klas', icon: 'http://media-cdn.visibacare.com/service/public/logo/google-play-badge.png' },
	];
	listOptionsLong = [
		{ value: 'Fredrik' },
		{ value: 'Görgen' },
		{ value: 'Klas' },
		{ value: 'Anna' },
		{ value: 'Karin' },
		{ value: 'Gustav' },
		{ value: 'Greta' },
		{ value: 'Karl' },
		{ value: 'Agneta' },
		{ value: 'Fredrik' },
		{ value: 'Görgen' },
		{ value: 'Klas' },
		{ value: 'Anna' },
		{ value: 'Karin' },
		{ value: 'Gustav' },
		{ value: 'Greta' },
		{ value: 'Karl' },
		{ value: 'Agneta' },
		{ value: 'Fredrik' },
		{ value: 'Görgen' },
		{ value: 'Klas' },
		{ value: 'Anna' },
		{ value: 'Karin' },
		{ value: 'Gustav' },
		{ value: 'Greta' },
		{ value: 'Karl' },
		{ value: 'Agneta' },
		{ value: 'Fredrik' },
		{ value: 'Görgen' },
		{ value: 'Klas' },
		{ value: 'Anna' },
		{ value: 'Karin' },
		{ value: 'Gustav' },
		{ value: 'Greta' },
		{ value: 'Karl' },
		{ value: 'Agneta' },
	];
	listOptionsShort = [{ value: 'Fredrik' }];
	listOptionsMuchText = [
		{ value: 'Dr. Fredrik göran pettersson' },
		{ value: 'Dr. Bartholomeus Maximiliam Amadeus Gustavsson' },
		{ value: 'Dr. Fredrik göran pettersson' },
		{ value: 'Dr. Bartholomeus Maximiliam Amadeus Gustavsson' },
		{ value: 'Dr. Fredrik göran pettersson' },
		{ value: 'Dr. Bartholomeus Maximiliam Amadeus Gustavsson' },
	];
	errorTextDynamic: string = null;
	saveBtn: any = {
		loading: false,
		success: false,
	};
	allIcons: Array<string> = [];

	constructor(
		private _svgIconRepository: VisibaSvgIconRepository,
		public _spaContext: SpaContext,
		private _builder: UntypedFormBuilder,
	) {
		this.formCG = _builder.group({
			requiredField: new UntypedFormControl(null, Validators.compose([Validators.required])),
			requiredFieldNin: new UntypedFormControl({ nin: null, countryCode: 'SE' }, Validators.compose([GlobalValidator.requiredNin])),
			requiredCheckboxField: new UntypedFormControl(null, Validators.compose([GlobalValidator.requiredCheckbox])),
			nationalIdentityNumber: new UntypedFormControl(
				{ nin: null, countryCode: 'SE' },
				Validators.compose([GlobalValidator.nationalIdentityFormat]),
			),
		});
		window.setInterval(() => {
			if (this.saveBtn.loading === false && this.saveBtn.success === false) {
				this.saveBtn.loading = true;
				this.saveBtn.success = false;
				this.saveBtn.error = false;
			} else if (this.saveBtn.loading === true) {
				this.saveBtn.loading = false;
				this.saveBtn.success = true;
				this.saveBtn.error = true;
				this.saveBtnDynamicErrorText.errorText = 'Ett errormeddelande kan skrivas här!';
			} else {
				this.saveBtn.loading = false;
				this.saveBtn.success = false;
				this.saveBtn.error = false;
			}
		}, 2000);

		this.allIcons = this._svgIconRepository.getIconsArray();
	}

	copyToClipboard(text: string) {
		var textarea = document.createElement('textarea') as HTMLTextAreaElement;

		// Place in top-left corner of screen regardless of scroll position.
		textarea.style.position = 'fixed';
		textarea.style.top = '0';
		textarea.style.left = '0';
		textarea.style.width = '1px';
		textarea.style.height = '1px';
		textarea.style.padding = '0';
		textarea.style.border = 'none';
		textarea.style.outline = 'none';
		textarea.style.boxShadow = 'none';
		textarea.style.background = 'transparent';

		document.body.appendChild(textarea);

		textarea.value = text;
		textarea.select();

		try {
			var status = document.execCommand('copy');
		} catch (err) {
			console.log('Unable to copy.', err);
		}
		document.body.removeChild(textarea);
	}

	public toggleShowAlias() {
		µ.Func.ToggleShowAlias();
	}
}
